import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const HalfRight = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="d3b28__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#d3b28__a)">
            <path
              fillRule="evenodd"
              d="m35.486 21.292 9.375 8.75a1.995 1.995 0 1 1-2.723 2.916l-9.482-8.85-14.374 14.306a1.995 1.995 0 0 1-2.815 0L3.592 26.595a1.995 1.995 0 0 1-.587-1.409v-.005a1.995 1.995 0 0 1 1.99-1.995H5a2 2 0 0 1 1.407.581l10.468 10.418 12.862-12.801-10.098-9.426a1.995 1.995 0 1 1 2.722-2.916l10.206 9.525 9.025-8.982A1.995 1.995 0 0 1 44.995 11v.004a1.995 1.995 0 0 1-.588 1.41l-8.92 8.878Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
